import * as React from "react";
import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";
import Add from "@mui/icons-material/Add";
import {
  Modal,
  ModalDialog,
  DialogTitle,
  DialogContent,
  FormControl,
  CircularProgress,
  FormLabel,
  Input,
  Button,
  Stack,
  Select,
  Option,
  Alert,
} from "@mui/joy";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import Sidebar from "../../../components/Sidebar";
import Header from "../../../components/Header";
import CategoryTable from "../../../components/CategoryTable";

import { addCategory } from "../../../api/methods";

const RequiredLabel: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography component="span">
    {children}{" "}
    <Typography component="span" sx={{ color: "red" }}>
      *
    </Typography>
  </Typography>
);

export default function Category() {
  const [open, setOpen] = React.useState<boolean>(false);
  const [type, setType] = React.useState("");
  const [code, setCode] = React.useState("");
  const [entity, setEntity] = React.useState("COMMUN");
  const [diagnosticCategory, setDiagnosticCategory] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState<string | null>(
    null
  );
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

  const handleType = (
    event: React.SyntheticEvent | null,
    newValue: string | null
  ) => {
    console.log(newValue);
    setType(newValue !== null ? newValue : "");
  };

  const resetForm = () => {
    setType("");
    setCode("");
    setEntity("COMMUN");
    setDiagnosticCategory("");
    setSuccessMessage(null);
    setErrorMessage(null);
  };

  React.useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      setLoading(true);
      await addCategory({
        type,
        code,
        diagnostic_category: diagnosticCategory,
        entity,
      });
      setSuccessMessage("Catégorie ajoutée avec succès");
      setTimeout(() => {
        setOpen(false);
      }, 2000);
    } catch (error) {
      setErrorMessage("Échec de l'ajout de la catégorie");
      console.error("Failed to add category:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100dvh" }}>
      <Header />
      <Sidebar />
      <Box
        component="main"
        className="MainContent"
        sx={{
          px: { xs: 2, md: 6 },
          pt: {
            xs: "calc(12px + var(--Header-height))",
            sm: "calc(12px + var(--Header-height))",
            md: 3,
          },
          pb: { xs: 2, sm: 2, md: 3 },
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          height: "100dvh",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Breadcrumbs
            size="sm"
            aria-label="breadcrumbs"
            separator={<ChevronRightRoundedIcon fontSize="small" />}
            sx={{ pl: 0 }}
          >
            <Link
              underline="none"
              color="neutral"
              href="#some-link"
              aria-label="Home"
            >
              <HomeRoundedIcon />
            </Link>
            <Typography color="primary" fontWeight={500} fontSize={12}>
              Liste des catégories
            </Typography>
          </Breadcrumbs>
        </Box>
        <Box
          sx={{
            display: "flex",
            mb: 1,
            gap: 1,
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "start", sm: "center" },
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <Typography level="h2" component="h1">
            Liste des catégories
          </Typography>
          <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setOpen(true)}
          >
            Ajouter Catégorie
          </Button>
          <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog sx={{ width: 400 }}>
              <DialogTitle>Ajouter une nouvelle catégorie</DialogTitle>
              <DialogContent>Remplissez les champs suivants</DialogContent>
              <DialogContent>Remplissez les champs suivants</DialogContent>
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <FormControl>
                    <RequiredLabel>Type</RequiredLabel>
                    <Select
                      value={type}
                      onChange={handleType}
                      autoFocus
                      required
                    >
                      <Option value="symptome">Symptome</Option>
                      <Option value="cause">Cause</Option>
                      <Option value="defaut">Défaut</Option>
                      <Option value="remede">Remede</Option>
                      <Option value="ensemble">Ensemble</Option>
                    </Select>
                  </FormControl>
                  <FormControl>
                    <RequiredLabel>Code</RequiredLabel>
                    <Input
                      value={code}
                      onChange={(event) => setCode(event.target.value)}
                      required
                    />
                  </FormControl>
                  <FormControl>
                    <RequiredLabel>Description du diagnostic</RequiredLabel>
                    <Input
                      value={diagnosticCategory}
                      onChange={(event: any) =>
                        setDiagnosticCategory(event.target.value)
                      }
                      required
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Entité</FormLabel>
                    <Input
                      defaultValue="COMMUN"
                      placeholder="COMMUN"
                      value={entity}
                      onChange={(event: any) => setEntity(event.target.value)}
                    />
                  </FormControl>
                  {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                  {successMessage && (
                    <Alert color="success">{successMessage}</Alert>
                  )}
                  <Button type="submit" disabled={loading}>
                    {loading ? <CircularProgress size="sm" /> : "Ajouter"}
                  </Button>
                </Stack>
              </form>
            </ModalDialog>
          </Modal>
        </Box>
        <CategoryTable />
      </Box>
    </Box>
  );
}
